import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
Vue.use(VueRouter)

// Route-level splitting keeps the large reader and management views out of the
// initial book-shelf payload while preserving Vue 2 compatibility.
const Home = () => import(/* webpackChunkName: "home" */ '../views/Home.vue')
const Library = () => import(/* webpackChunkName: "library" */ '../views/Library.vue')
const Upload = () => import(/* webpackChunkName: "library-tools" */ '../views/Upload.vue')
const Reader = () => import(/* webpackChunkName: "reader" */ '../views/Reader.vue')
const PdfReader = () => import(/* webpackChunkName: "pdf-reader" */ '../views/PdfReader.vue')
const Listen = () => import(/* webpackChunkName: "audio-player" */ '../views/Listen.vue')
const BookDetail = () => import(/* webpackChunkName: "book-detail" */ '../views/BookDetail.vue')
const Search = () => import(/* webpackChunkName: "search" */ '@/views/Search.vue')
const Notes = () => import(/* webpackChunkName: "account" */ '../views/Notes.vue')
const Profile = () => import(/* webpackChunkName: "account" */ '../views/Profile.vue')
const Login = () => import(/* webpackChunkName: "auth" */ '../components/Login.vue')
const Register = () => import(/* webpackChunkName: "auth" */ '../components/Register.vue')

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { title: '最近' }
  },
  {
    path: '/library',
    name: 'Library',
    component: Library,
    meta: { requiresAuth: true, title: '我的书库' }
  },
  {
    path: '/discover',
    name: 'Discover',
    component: Library,
    meta: { title: '公共书库' },
    props: { publicOnly: true }
  },
  {
    path: '/upload',
    name: 'Upload',
    component: Upload,
    meta: { requiresAuth: true, title: '添加内容' }
  },
  {
    path: '/book/:id',
    name: 'BookDetail',
    component: BookDetail,
    meta: { title: '内容详情' },
    props: route => ({
      bookId: route.params.id ? Number(route.params.id) : null
    })
  },
  {
    path: '/reader/:bookId',
    name: 'Reader',
    component: Reader,
    meta: { title: '阅读', noShell: true },
    props: route => ({
      bookId: route.params.bookId ? Number(route.params.bookId) : null
    })
  },
  {
    path: '/pdf/:bookId',
    name: 'PdfReader',
    component: PdfReader,
    meta: { title: 'PDF 阅读', noShell: true },
    props: route => ({ bookId: Number(route.params.bookId) })
  },
  {
    path: '/listen/:bookId',
    name: 'Listen',
    component: Listen,
    meta: { title: '有声书', noShell: true },
    props: route => ({ bookId: Number(route.params.bookId) })
  },
  {
    path: '/search',
    name: 'Search',
    component: Search,
    meta: { title: '搜索' }
  },
  {
    path: '/notes',
    name: 'Notes',
    component: Notes,
    meta: { requiresAuth: true, title: '我的笔记' }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: { requiresAuth: true, title: '个人中心' }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { title: '登录', noShell: true }
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: { title: '注册', noShell: true }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 添加导航守卫进行调试
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const isAuthenticated = store.state.token;

  // 添加页面标题
  if (to.meta.title) {
    document.title = `${to.meta.title} - 翻书`;
  }

  if (requiresAuth && !isAuthenticated) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    });
  } else {
    next();
  }
});

export default router
